<template>
  <div class="team-mall-order">
    <el-card v-if="!showDetails" shadow="never" style="min-height: 700px">
      <div slot="header" class="clearfix">
        <div class="desciconLarge"></div>
        <span class="font18">商城订单</span>
      </div>

      <div class="topHandle">
        <div class="search-box">
          <el-input class="box-item" clearable placeholder="输入订单编号" v-model.trim="queryParams.orderNo" prefix-icon="el-icon-search" />
          <el-input class="box-item" clearable placeholder="输入商品名称" v-model.trim="queryParams.productName" prefix-icon="el-icon-search" />
          <el-select class="box-item" v-model="queryParams.payType" clearable placeholder="请选择支付方式">
            <el-option v-for="item in payTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-date-picker
            class="box-item date-item"
            v-model="dateList"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeDate">
          </el-date-picker>
          <div class="search-actions">
            <el-button @click="resetParams">重置</el-button>
            <el-button type="primary" @click="getSearch">搜索</el-button>
          </div>
        </div>
      </div>

      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="tab in tabsList" :key="tab.value" :label="tabLabel(tab)" :name="tab.value">
          <div class="table_head">
            <div class="table_head_col" :style="{ width: item.width }" v-for="item in headList" :key="item.index">{{ item.name }}</div>
          </div>
          <div class="table_content" v-loading="loading">
            <el-empty v-if="tableData.length === 0" description="暂无商城订单"></el-empty>
            <div class="table_content_card" v-for="item in tableData" :key="item.orderId">
              <div class="table_card_head">
                <span>下单时间：{{ item.addDate || '-' }}</span>
                <span>申请人：{{ item.clientName || '-' }}</span>
                <span>订单号：{{ item.orderNo || '-' }}</span>
                <span>物流信息：{{ shipmentSummary(item) }}</span>
              </div>
              <div class="table_card_body" @click="toDetails(item)">
                <div class="table_body_name">
                  <div class="product-icon">
                    <i class="el-icon-shopping-bag-2"></i>
                  </div>
                  <div class="product-name">{{ item.firstGoodsName || '-' }}</div>
                </div>
                <div class="table_body_othername">{{ getPayTypeText(item.payType) }}</div>
                <div class="table_body_othername amount-cell">￥{{ formatAmount(item.totalAmount) }}</div>
                <div class="table_body_othername">
                  <span class="status-badge" :class="`status-${getStatusAlias(item.orderStatus)}`">{{ getOrderStatusText(item.orderStatus) }}</span>
                </div>
                <div class="table_body_othername">{{ getInvoiceStatusText(item.invoiceStatus) }}</div>
                <div class="table_body_btn">
                  <template v-if="String(item.orderStatus) === '5'">
                    <div class="clickName" @click.stop="approveOrder(item)">通过</div>
                    <div class="clickName" @click.stop="rejectOrder(item)">拒绝</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="table-footer">
            <el-pagination background v-if="total > 0"
              layout="total,prev, pager, next,sizes,jumper"
              :current-page="queryParams.pageNum"
              :page-size="queryParams.pageSize"
              :total="total"
              @current-change="selPageChange"
              @size-change="handleSizeChange">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <mall-order-details
      v-if="showDetails"
      ref="mallOrderDetails"
      :client-id="detailClientId"
      order-type="team"
      @close="closeDetails">
    </mall-order-details>
  </div>
</template>

<script>
import {
  approveTeamMallOrder,
  rejectTeamMallOrder,
  teamMallOrderList,
  teamMallOrderStatusCount
} from "@/api/request";
import MallOrderDetails from "./mallOrderDetails.vue";
import { getClient, getReagentTeamInfo } from "@/plugins/auth";

function readStorageObject(getter) {
  try {
    return JSON.parse(getter() || '{}')
  } catch (error) {
    return {}
  }
}

export default {
  components: { MallOrderDetails },
  data() {
    return {
      loading: false,
      showDetails: false,
      detailClientId: '',
      activeName: '-1',
      dateList: [],
      total: 0,
      tableData: [],
      queryParams: this.getDefaultQueryParams(),
      statusCount: {
        all: 0,
        pending: 0,
        audit: 0,
        processing: 0,
        shipped: 0,
        delivered: 0,
        cancelled: 0,
        auditRejected: 0
      },
      payTypeList: [
        { value: '1', label: '个人预存' },
        { value: '2', label: '团队预存' },
        { value: '3', label: '支付宝' },
        { value: '4', label: '微信' },
        { value: '5', label: '个人信用' },
        { value: '6', label: '团队信用' }
      ],
      tabsList: [
        { label: '全部订单', value: '-1', countKey: 'all' },
        { label: '待支付', value: '0', countKey: 'pending' },
        { label: '待审核', value: '5', countKey: 'audit' },
        { label: '待发货', value: '1', countKey: 'processing' },
        { label: '待收货', value: '2', countKey: 'shipped' },
        { label: '已完成', value: '3', countKey: 'delivered' },
        { label: '已取消', value: '4', countKey: 'cancelled' },
        { label: '审核拒绝', value: '6', countKey: 'auditRejected' }
      ],
      headList: [
        { name: '商品名称', index: 1, width: '240px' },
        { name: '支付方式', index: 2, width: '100px' },
        { name: '应付款', index: 3, width: '130px' },
        { name: '订单状态', index: 4, width: '100px' },
        { name: '发票状态', index: 5, width: '100px' },
        { name: '操作', index: 6, width: '120px' }
      ]
    }
  },
  mounted() {
    this.fetchOrdersAndCount()
  },
  methods: {
    getDefaultQueryParams() {
      return {
        pageNum: 1,
        pageSize: 10,
        orderNo: '',
        productName: '',
        payType: '',
        startDate: '',
        endDate: ''
      }
    },
    getRmTeamId() {
      return readStorageObject(getReagentTeamInfo).rmTeamId || ''
    },
    getOperatorClientId() {
      return readStorageObject(getClient).clientId || ''
    },
    tabLabel(tab) {
      if (tab.value === '-1') return tab.label
      return `${tab.label}(${this.statusCount[tab.countKey] || 0})`
    },
    buildQueryParams() {
      const params = {
        ...this.queryParams,
        rmTeamId: this.getRmTeamId(),
        orderStatus: this.activeName
      }
      return params
    },
    async getList() {
      const rmTeamId = this.getRmTeamId()
      if (!rmTeamId) {
        this.tableData = []
        this.total = 0
        return
      }
      this.loading = true
      try {
        const res = await teamMallOrderList(this.buildQueryParams())
        this.tableData = Array.isArray(res && res.rows)
          ? res.rows
          : (res && res.data && Array.isArray(res.data.rows) ? res.data.rows : [])
        this.total = Number((res && res.total) || (res && res.data && res.data.total)) || this.tableData.length
      } catch (error) {
        this.tableData = []
        this.total = 0
        this.$message.error((error && error.message) || '商城订单加载失败')
      } finally {
        this.loading = false
      }
    },
    async fetchStatusCount() {
      const rmTeamId = this.getRmTeamId()
      if (!rmTeamId) return
      const res = await teamMallOrderStatusCount({ rmTeamId })
      const data = res && res.data
      if (!data) return
      this.statusCount = {
        all: Number(data.all) || 0,
        pending: Number(data.pending) || 0,
        audit: Number(data.audit) || 0,
        processing: Number(data.processing) || 0,
        shipped: Number(data.shipped) || 0,
        delivered: Number(data.delivered) || 0,
        cancelled: Number(data.cancelled) || 0,
        auditRejected: Number(data.auditRejected) || 0
      }
    },
    async fetchOrdersAndCount() {
      try {
        await Promise.all([this.getList(), this.fetchStatusCount()])
      } catch (error) {
        this.$message.error((error && error.message) || '商城订单数据加载失败')
      }
    },
    getPayTypeText(payType) {
      const item = this.payTypeList.find(option => option.value === String(payType))
      return item ? item.label : '--'
    },
    getOrderStatusText(status) {
      const statusMap = {
        '0': '待支付',
        '1': '待发货',
        '2': '待收货',
        '3': '已完成',
        '4': '已取消',
        '5': '待审核',
        '6': '审核拒绝'
      }
      return statusMap[String(status)] || '--'
    },
    getStatusAlias(status) {
      const statusMap = {
        '0': 'pending',
        '1': 'processing',
        '2': 'shipped',
        '3': 'delivered',
        '4': 'cancelled',
        '5': 'audit',
        '6': 'auditRejected'
      }
      return statusMap[String(status)] || 'processing'
    },
    getInvoiceStatusText(status) {
      const statusMap = {
        '1': '未开票',
        '2': '已开票',
        '3': '无需开票'
      }
      return statusMap[String(status)] || '--'
    },
    shipmentSummary(order) {
      if (!order || (!order.carrierName && !order.trackingNo)) return '--'
      return [order.carrierName, order.trackingNo].filter(Boolean).join(' / ')
    },
    formatAmount(value) {
      return Number(value || 0).toFixed(2)
    },
    handleClick() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    changeDate(dateList) {
      this.queryParams.startDate = dateList ? dateList[0] : ''
      this.queryParams.endDate = dateList ? dateList[1] : ''
    },
    getSearch() {
      this.queryParams.pageNum = 1
      this.fetchOrdersAndCount()
    },
    resetParams() {
      this.activeName = '-1'
      this.dateList = []
      this.queryParams = this.getDefaultQueryParams()
      this.fetchOrdersAndCount()
    },
    selPageChange(page) {
      this.queryParams.pageNum = page
      this.getList()
    },
    handleSizeChange(pageSize) {
      this.queryParams.pageSize = pageSize
      this.queryParams.pageNum = 1
      this.getList()
    },
    toDetails(order) {
      if (!order || !order.orderId || !order.clientId) {
        this.$message.error('订单详情参数不完整')
        return
      }
      this.detailClientId = order.clientId
      this.showDetails = true
      this.$nextTick(() => {
        this.$refs.mallOrderDetails.getOrderInfo(order.orderId)
      })
    },
    closeDetails() {
      this.showDetails = false
      this.detailClientId = ''
      this.getList()
    },
    async approveOrder(order) {
      const clientId = this.getOperatorClientId()
      if (!clientId || !order || !order.orderId || !order.clientId) return
      try {
        await this.$confirm('确认通过该订单审核吗？', '审核订单', {
          confirmButtonText: '通过',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false
        })
      } catch (error) {
        return
      }
      try {
        await approveTeamMallOrder({
          clientId,
          orderIdClientId: order.clientId,
          orderId: order.orderId
        })
        this.$message.success('审核已通过')
        await this.fetchOrdersAndCount()
      } catch (error) {
        this.$message.error((error && error.message) || '审核通过失败')
      }
    },
    async rejectOrder(order) {
      const clientId = this.getOperatorClientId()
      if (!clientId || !order || !order.orderId) return
      try {
        await this.$confirm('确认拒绝该订单审核吗？', '审核订单', {
          confirmButtonText: '拒绝',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false
        })
      } catch (error) {
        return
      }
      try {
        await rejectTeamMallOrder({
          clientId,
          orderId: order.orderId
        })
        this.$message.success('订单已拒绝')
        await this.fetchOrdersAndCount()
      } catch (error) {
        this.$message.error((error && error.message) || '审核拒绝失败')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.topHandle {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.search-box {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.box-item {
  width: 180px;
}

.date-item {
  width: 260px;
}

.search-actions {
  display: flex;
  gap: 10px;
  margin-left: auto;
  white-space: nowrap;
}

.table_head {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
  padding: 20px;
  border-radius: 7px;
  background: #f5f5f5;
  color: #111;
  font-size: 14px;
  text-align: center;
}

.table_content {
  width: 100%;
  min-height: 500px;
  overflow: auto;
}

.table_content_card {
  margin-bottom: 20px;
  border: 1px solid #e0e2ff;
  border-radius: 7px;
}

.table_card_head {
  height: 36px;
  padding-left: 20px;
  border-bottom: 1px solid #e0e2ff;
  background: #eaeffa;
  color: #666;
  font-size: 14px;
  line-height: 36px;
}

.table_card_head span {
  margin-right: 50px;
}

.table_card_body {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 20px;
  color: #111;
  font-size: 14px;
  text-align: center;
}

.table_body_name {
  display: flex;
  align-items: center;
  width: 240px;
  text-align: left;
}

.product-icon {
  display: flex;
  flex: 0 0 80px;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 56px;
  margin-right: 10px;
  border-radius: 12px;
  background: #f6f8ff;
  color: #4d6fff;
  font-size: 28px;
}

.product-name {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.table_body_othername {
  width: 100px;
  word-break: break-all;
}

.amount-cell {
  width: 130px;
}

.table_body_btn {
  width: 120px;
}

.table-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
}

.status-pending { background: #fff3e7; color: #c2410c; }
.status-audit { background: #fff8db; color: #a16207; }
.status-processing { background: #eaf1ff; color: #315fdc; }
.status-shipped { background: #f0eaff; color: #6d28d9; }
.status-delivered { background: #e7f8eb; color: #168239; }
.status-cancelled { background: #eef0f3; color: #666; }
.status-auditRejected { background: #fff0f0; color: #dc2626; }
</style>
